/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable no-unexpected-multiline */
import React, { useEffect, useState } from 'react'

import {
  Card,
  Span,
  Row,
  Col,
  TableBodyStyled,
  TableCellStyled,
  TableRowStyled,
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  Button,
  Grid,
  Text,
  TableFooter,
  Line,
  PageFooter
} from 'components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Box, LinearProgress } from '@mui/material'
import { LoadingIcon } from 'components/Icons'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useAuth, useException, useLoading, useModal } from 'hooks'
import moment from 'moment'
import { useHistory, useLocation } from 'react-router-dom'
import {
  IMotivosResponse,
  IResponseResultGroups,
  IResponseResultGroupsItems,
  ReportsBlockServices
} from 'services/NGT/ReportsBlock'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import { createArrayCopy } from 'utils/functions'
import CollapseColumnBlock from '../components/CollapseColumnBlock/CollapseColumnBlock'
import { hasTokenRefreshError } from 'services/Instances/utils'

interface CollapseProps {
  isOpen: boolean
  content: any
}

interface TotalProps {
  totalRisco: number
  totalRiscoSemFR: number
  totalGeralRisco: number
  totalGeralRiscoDifNGT: number
  totalRiscoNGT: number
}

const RecordSheetBlockFullSuplier: React.FC = () => {
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()
  const [downloadExcel, setDownloadExcel] = useState<boolean>(false)
  const { goBack } = useHistory()
  const { state } = useLocation<any>()
  const [grupos, setGrupos] = useState<CollapseProps[]>([])
  const [dataEmissao, setDataEmissao] = useState('')
  const [tituloRelatorio, setTituloRelatorio] = useState('')
  const [page, setPage] = useState(1)
  const [totalItensPaginated, setTotalItensPaginated] = useState<number>(0)
  const [hasMore, setHasMore] = useState<boolean>(true)
  const [total, setTotal] = useState<TotalProps>({} as TotalProps)
  const [motivos, setMotivos] = useState<IMotivosResponse[]>([])
  const [showCollapse, setShowCollapse] = useState(false);

  const formatedPageTitle =
    tituloRelatorio
      ?.replaceAll(' ', '-')
      ?.replaceAll('--', '')
      ?.replaceAll('---', '')
      ?.toLowerCase() || 'relatorio-cre'

  const dateNow = moment().format('DD-MM-YYYY')
  const timeNow = moment().format('HH-mm-ss')
  const formatTime = timeNow.replace('-', 'h').replace('-', 'm').concat('s')
  const dateAndTimeNow = `-${dateNow}-${formatTime}`
  const fileName = `${formatedPageTitle}${dateAndTimeNow}`

  useEffect(() => {
    if (!state) {
      goBack()
      return
    }
    getRelatorioTotal() // Chama a função ActionCheckbox
  }, [])

  const getRelatorioTotal = async () => {
    if (page == 1) {
      setLoading('loading')
    }

    const objEnvio = {
      ...state.requestVisualizar,
      pageNumber: page,
      pageSize: 15,
      flTotais: true
    }

    ReportsBlockServices()
      .getRelatorioFinal(objEnvio)
      .then((response) => {
        if (response.data?.entity?.mensagem || !response.data?.sucesso) {
          showModal({
            handleConfirm: () => {
              goBack()
            },
            hideButtonCancel: true,
            message:
              response.data.mensagem ||
              'Não há dados para o relatório selecionado!',
            titleModal: 'Atenção',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })

          setLoading('idle')
          return
        }

        setMotivos(response.data?.entity?.motivos)

        setTotal({
          totalRisco: response.data?.entity?.totalRisco,
          totalRiscoSemFR: response.data?.entity?.totalRiscoSemFR,
          totalGeralRisco: response.data?.entity?.totalGeralRisco,
          totalGeralRiscoDifNGT: response.data?.entity?.totalGeralRiscoDifNGT,
          totalRiscoNGT: response.data?.entity?.totalRiscoNGT
        })

        setLoading('idle')
      })
      .catch((error) => {
        setMsgErro(
          error.response.data?.mensagem ||
          error.response?.data?.mensage ||
          'Erro ao obter dados do relatório.'
        )
        setLoading('error')
      })
  }

  const getRelatorio = async () => {
    if (page == 1) {
      setLoading('loading')
    }

    const objEnvio = {
      ...state.requestVisualizar,
      pageNumber: page,
      pageSize: 15
    }

    if (page > 1) {
      if (totalItensPaginated <= grupos?.length) {
        setHasMore(false)
        setLoading('idle')
        return
      }
    }

    ReportsBlockServices()
      .getRelatorioFinal(objEnvio)
      .then((response) => {
        if (response.data?.entity?.mensagem || !response.data?.sucesso) {
          showModal({
            handleConfirm: () => {
              goBack()
            },
            hideButtonCancel: true,
            message:
              response.data.mensagem ||
              'Não há dados para o relatório selecionado!',
            titleModal: 'Atenção',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })

          setLoading('idle')
          return
        }

        const receivedGroups = response.data?.entity?.groups?.map((group) => ({
          content: group,
          isOpen: false
        }))

        if (response?.data?.entity?.groups.length > 0) {
          setGrupos((prevState) => prevState.concat([...receivedGroups]))
        }
        const verifyCollapseReport = response.data?.entity?.groups?.every((group) => {
          return (
            group.cdContratoPend === null &&
            group.nmFornecedor === null &&
            group.nmContraparte === null &&
            group.de === null &&
            group.dir === null &&
            group.gg === null &&
            group.ger === null &&
            group.nmSolicitanteBloqueio === null &&
            group.motivoBloqueio === null &&
            group.vlRisco === 0 &&
            group.dtBloqueio === '01/01/0001' &&
            group.dtLiberacao === '01/01/0001' &&
            group.observacao === null &&
            group.totalFRs === null &&
            group.vlRiscoTotalGeral === 0 &&
            group.vlRiscoTotalSemFR === 0
          )
        })
        if (verifyCollapseReport)
          setShowCollapse(false);
        else
          setShowCollapse(true);

        setDataEmissao(response.data?.entity?.dtEmissao)
        setTituloRelatorio(response.data?.entity?.txTitle)
        if (page === 1) {
          setTotalItensPaginated(response.data?.entity?.totalItensPaginated)
        }

        setPage(page + 1)
        setLoading('idle')
      })
      .catch((error) => {
        setMsgErro(
          error.response.data?.mensagem ||
          error.response?.data?.mensage ||
          'Erro ao obter dados do relatório.'
        )
        setLoading('error')
      })
  }

  const handleExcel = () => {
    const objEnvio = { ...state.requestVisualizar }
    setDownloadExcel(true)

    ReportsBlockServices()
      .getRelatorioExcel(objEnvio)
      .then((response) => {
        const url =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
          response.data
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download = 'relatorio-de-bloqueio.xlsx'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        setDownloadExcel(false)
      })
      .catch(() => {
        // setMsgErro('Não foi possivel baixar excel.')
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'Não foi possivel baixar excel.',
          type: 'error'
        })
        setDownloadExcel(false)
      })
  }

  const handleCollpasePdf = (index) => {
    const cpy = createArrayCopy(grupos)
    cpy[index].isOpen = !cpy[index].isOpen
    setGrupos(cpy)
  }

  return (
    <>
      <Card
        id="divToPrint"
        boxShadow="0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12);"
        borderRadius="0px 10px 0px 0px"
        marginTop={SPACING.spacing20}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
      >
        <Card
          marginTop={SPACING.spacing20}
          marginRight={SPACING.spacing20}
          marginBottom={SPACING.spacing100}
          padding={SPACING.spacing20}
          boxShadow={`0 0 1em ${COLORS.lightGray}`}
        >
          <RowPdfExcel
            handleExcel={handleExcel}
            downloadExcel={downloadExcel}
            grupos={grupos}
            dataEmissao={dataEmissao}
            tituloRelatorio={tituloRelatorio}
            request={{
              ...state?.requestVisualizar,
              pageSize: totalItensPaginated,
              pageNumber: 1
            }}
            filename={fileName}
          />
          <InfiniteScroll
            dataLength={grupos.length}
            next={getRelatorio}
            hasMore={hasMore}
            loader={
              <Box sx={{ width: '100%', marginBottom: '20px' }}>
                <LinearProgress />
              </Box>
            }
            endMessage={
              <p style={{ textAlign: 'center' }}>
                <b>Final da listagem</b>
              </p>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>&#8593; Atualizando...</h3>
            }
          >
            {grupos?.map((el: any, index: number) => {
              return (
                <CollapseColumnBlock
                  key={index.toString()}
                  nuContrato={el?.content.cdContratoPend}
                  nmFornecedor={el?.content.nmFornecedor}
                  nmContraparte={el?.content.nmContraparte}
                  nmDiretoriaExecutiva={el?.content.de}
                  nmDiretoria={el?.content.dir}
                  nmGerenciaGeral={el?.content.gg}
                  nmGerencia={el?.content.ger}
                  nmSolicitanteBloqueio={el?.content.nmSolicitanteBloqueio}
                  motivoBloqueio={el?.content.motivoBloqueio}
                  vlRisco={el?.content.vlRisco}
                  dataBloqueio={el?.content.dtBloqueio.substr(0, 10)}
                  dataLiberacao={el?.content.dtLiberacao.substr(0, 10)}
                  dataEmissao={dataEmissao}
                  isOpen={true}
                  toggleExpand={handleCollpasePdf}
                  index={index}
                  showCollapse={showCollapse}
                >
                  {showCollapse ? (
                    <>
                      <TableSupplierView data={el.content?.itens} />
                      <InfoSupplierBlock
                        observacao={el?.content?.observacao}
                        vlRiscoTotal={el?.content?.totalFRs}
                        vlRiscoTotalGeral={el?.content?.vlRiscoTotalGeral}
                        vlRiscoTotalSemFR={el?.content?.vlRiscoTotalSemFR}
                      />
                    </>) : null}
                </CollapseColumnBlock>
              )
            })}
          </InfiniteScroll>
          <PageFooter>
            <Span
              fontSize={TYPOGRAPHY.bodySize16}
              text="Estes valores são referentes aos riscos"
              fontWeight={FONTS.regular}
              style={{
                marginTop: '0.5rem',
                textAlign: 'center',
                display: 'block',
                color: '#004C97',// Cor do texto
                lineHeight: '1.5', // Altura da linha para melhor legibilidade
                fontWeight: 'bold'
              }}
            />

            <Grid
              gridCols="1fr 1fr 1fr 1fr"
              gridGap="1rem"
              margin="0 1rem 0 1rem"
            >
              {[...Array(Math.ceil(motivos.length / 3))].map(
                (_, columnIndex) => (
                  <Col key={columnIndex}>
                    {motivos
                      .slice(columnIndex * 3, columnIndex * 3 + 3)
                      .map((mot, rowIndex) => (
                        <Row key={rowIndex} style={{ marginTop: '20px' }}>
                          <Span
                            fontSize={TYPOGRAPHY.bodySize14}
                            text={`${mot?.motivoBloqueio}`}
                          />
                          <Span
                            fontSize={TYPOGRAPHY.bodySize14}
                            fontWeight={FONTS.bold}
                            text={`: ${FORMAT.currency(mot.totalRisco)}`}
                          />
                        </Row>
                      ))}
                  </Col>
                )
              )}
            </Grid>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '0.1rem', position: 'fixed', right: '8rem', bottom: '7.1rem', justifyContent: "center" }}>
              <div style={{
                width: '0.8rem',
                height: '0.8rem',
                backgroundColor: 'red',
                borderRadius: '50%',
                marginRight: '0.5rem',
              }}></div>
              <Span
                fontSize={TYPOGRAPHY.bodySize14}
                text="Totalizador dos Riscos"
                style={{ fontWeight: "inherit", marginTop: "0.15rem" }}
              />
            </div>
            <Grid>
              <TableContainerStyled>
                <TableStyled>
                  <TableHeadStyled>
                    <TableRowStyled>
                      <TableCellStyled align="center">
                        Total FR: {FORMAT.currency(total?.totalRisco)}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        Total FR (NGT): {FORMAT.currency(total?.totalRiscoNGT)}
                      </TableCellStyled>
                      <TableCellStyled align="center" style={{ color: "red" }}>
                        Total Risco sem FR:
                        {FORMAT.currency(total?.totalRiscoSemFR)}
                      </TableCellStyled>
                      <TableCellStyled align="center" style={{ color: "red" }}>
                        Total Geral Risco(NGT):
                        {FORMAT.currency(total?.totalGeralRisco)}
                      </TableCellStyled>
                      <TableCellStyled align="center" style={{ color: "red" }}>
                        Total Geral Risco:
                        {FORMAT.currency(total?.totalGeralRiscoDifNGT)}
                      </TableCellStyled>
                    </TableRowStyled>
                  </TableHeadStyled>
                  <TableBodyStyled>
                    <TableRowStyled style={{ background: COLORS.lightGray }}>
                      <TableCellStyled align="center"></TableCellStyled>
                      <TableCellStyled align="center"></TableCellStyled>
                      <TableCellStyled align="center"></TableCellStyled>
                    </TableRowStyled>
                  </TableBodyStyled>
                </TableStyled>
              </TableContainerStyled>
            </Grid>
            <Line background={COLORS.blueFonts} />
            <Row justifyContent="flex-end" marginTop={SPACING.spacing20}></Row>
          </PageFooter>
        </Card>
      </Card>
    </>
  )
}

const RowPdfExcel = ({
  handleExcel,
  downloadExcel,
  grupos,
  dataEmissao,
  tituloRelatorio,
  request,
  filename
}: {
  handleExcel: () => void
  downloadExcel: boolean
  grupos: CollapseProps[]
  dataEmissao: string
  tituloRelatorio: string
  request: any
  filename: string
}) => {
  const INVALID_DATE = '01/01/2001'

  const [loadingPDF, setLoadingPDF] = useState<boolean>(false)
  const [textLoadingPDF, setTextLoadingPDF] = useState<string>('')
  const [textLoadingExcel, setTextLoadingExcel] = useState<string>(
    'Começamos a gerar o seu Excel, Aguarde um momento.'
  )
  const { user } = useAuth()
  const { createCustomException } = useException()
  const { showModal } = useModal()
  const { goBack } = useHistory()

  const handlePrintPdf = () => {
    setLoadingPDF(true)
    setTextLoadingPDF(`Começamos a gerar seu PDF, Aguarde um momento.`)
    ReportsBlockServices()
      .getPDFResult(user.IdUsuario, {
        ...request
      })
      .then((response) => {
        if (response?.status !== 200) {
          createCustomException({
            message: 'Ocorreu um erro ao gerar o relatório'
          })
          setTextLoadingPDF('')
          setLoadingPDF(false)
        }

        if (response.data.length < 67) {
          showModal({
            hideButtonCancel: true,
            message: response.data,
            txtButtonConfirm: 'Fechar',
            type: 'success'
          })
          setTextLoadingPDF('')
          setLoadingPDF(false)
          return
        }

        const url = 'data:application/pdf;base64,' + response.data
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download = `${filename}.pdf`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        setTextLoadingPDF('')
        setLoadingPDF(false)
      })
      .catch((error) => {
        showModal({
          hideButtonCancel: true,
          message: 'Ocorreu um problema ao gerar PDF.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
        setLoadingPDF(false)
        setTextLoadingPDF('')
      })
  }

  return (
    <Row
      alignItems="center"
      justifyContent="flex-end"
      marginTop={SPACING.spacing15}
      marginBottom={SPACING.spacing15}
    >
      {loadingPDF ? (
        <>
          <Grid justifyItems="center" gridCols="1fr" gridGap="1rem">
            <LoadingIcon colorIcon={COLORS.blueFonts} />
            <Span text={`${textLoadingPDF}`} />
          </Grid>
        </>
      ) : (
        <>
          <Button
            marginTop={SPACING.spacing20}
            marginBottom={SPACING.spacing20}
            marginRight={SPACING.spacing5}
            text="Voltar"
            variantButton="outlined"
            onClick={() => goBack()}
          />
          <PdfIcon onClick={handlePrintPdf} />
        </>
      )}
      {downloadExcel ? (
        <>
          <Grid justifyItems="center" gridCols="1fr" gridGap="1rem">
            <LoadingIcon colorIcon={COLORS.blueFonts} />
            <Span text={`${textLoadingExcel}`} />
          </Grid>
        </>
      ) : (
        <ExcelIcon style={{ marginLeft: `{SPACING.spacing15}` }} onClick={handleExcel} />
      )}
    </Row>
  )
}

export interface IBloqueioItemValue {
  idContratoCobr: number
  cdContratoCobr: string
  txDocumento: string
  tpDoc: string
  bloqPagto: string
  formPagto: string
  descricao: string
  vlLiquido: number
  vencimento: any
  folhaRegServ: string
}

const TableSupplierView = ({ data }: { data: IBloqueioItemValue[] }) => (
  <TableContainerStyled>
    <TableStyled>
      <TableHeadStyled>
        <TableRowStyled>
          <TableCellStyled align="left">Contrato</TableCellStyled>
          <TableCellStyled align="left">Nº Documento</TableCellStyled>
          <TableCellStyled align="left">Tipo Documento</TableCellStyled>
          <TableCellStyled align="left">Bloq Pagamento</TableCellStyled>
          <TableCellStyled align="left">Forma Pagamento</TableCellStyled>
          <TableCellStyled align="left">Descrição</TableCellStyled>
          <TableCellStyled align="left">Valor Líquido</TableCellStyled>
          <TableCellStyled align="left">Vencimento</TableCellStyled>
          <TableCellStyled align="left">Folha Registro Serv</TableCellStyled>
        </TableRowStyled>
      </TableHeadStyled>
      <TableBodyStyled>
        {data?.map((el) => (
          <TableRowStyled key={el.idContratoCobr}>
            <TableCellStyled align="left">
              {el.cdContratoCobr || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.txDocumento || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.tpDoc || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.bloqPagto || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.formPagto || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.descricao || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.currency(el.vlLiquido) || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {moment(el.vencimento).isValid()
                ? moment(el.vencimento).format('DD/MM/YYYY')
                : '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.folhaRegServ || '- - - -'}
            </TableCellStyled>
          </TableRowStyled>
        ))}
        <TableRowStyled style={{ background: COLORS.lightGray }}>
          <TableCellStyled></TableCellStyled>
          <TableCellStyled>TOTAL</TableCellStyled>
          <TableCellStyled></TableCellStyled>
          <TableCellStyled></TableCellStyled>
          <TableCellStyled></TableCellStyled>
          <TableCellStyled></TableCellStyled>
          <TableCellStyled>
            {FORMAT.currency(
              data
                .map((value) => value.vlLiquido)
                .reduce((current, previous) => current + previous, 0)
            )}
          </TableCellStyled>
          <TableCellStyled></TableCellStyled>
          <TableCellStyled></TableCellStyled>
        </TableRowStyled>
      </TableBodyStyled>
    </TableStyled>
  </TableContainerStyled>
)

const InfoSupplierBlock = ({
  observacao,
  vlRiscoTotal,
  vlRiscoTotalGeral,
  vlRiscoTotalSemFR
}) => (
  <>
    <Row alignItems="center" marginTop={SPACING.spacing20}>
      <Span
        text="OBS DE BLOQUEIO:"
        fontSize={TYPOGRAPHY.bodySize16}
        color={COLORS.black}
        fontWeight={FONTS.bold}
        marginRight={SPACING.spacing5}
      />
      <Span text={observacao} fontSize="13px" color={COLORS.black} />
    </Row>
    <Grid
      gridCols="1fr 1fr 1fr"
      gridGap={`0 ${SPACING.spacing5}`}
      margin={`${SPACING.spacing15} 0 ${SPACING.spacing15} 0`}
    >
      <Row alignItems="center">
        <Span
          text="Total de FR:"
          fontSize={TYPOGRAPHY.bodySize16}
          color={COLORS.black}
          fontWeight={FONTS.bold}
          marginRight={SPACING.spacing5}
        />
        <Span
          text={FORMAT.currency(vlRiscoTotal)}
          fontSize="13px"
          color={COLORS.black}
        />
      </Row>
      <Row alignItems="center">
        <Span
          text="Total de Risco sem FR:"
          fontSize={TYPOGRAPHY.bodySize16}
          color={COLORS.black}
          fontWeight={FONTS.bold}
          marginRight={SPACING.spacing5}
        />
        <Span
          text={FORMAT.currency(vlRiscoTotalSemFR)}
          fontSize="13px"
          color={COLORS.black}
        />
      </Row>
      <Row alignItems="center" marginLeft={SPACING.spacing20}>
        <Span
          text="Total Geral do Risco:"
          fontSize={TYPOGRAPHY.bodySize16}
          color={COLORS.black}
          fontWeight={FONTS.bold}
          marginRight={SPACING.spacing5}
        />
        <Span
          text={FORMAT.currency(vlRiscoTotalGeral)}
          fontSize="13px"
          color={COLORS.black}
        />
      </Row>
    </Grid>
  </>
)

export default RecordSheetBlockFullSuplier
